import DashboardLayoutMod from "@/views/Layout/DashboardLayout";
import ActividadLista from "@/components/Ciudadano/ResumenTramites/ActividadLista/ActividadLista";
import AfiliacionWizard from "@/components/Ciudadano/Afiliacion/AfiliacionWizard/AfiliacionWizard";
import VerAfiliacion from "@/components/Ciudadano/ResumenTramites/VerAfiliacion/VerAfiliacion";
import FichaAfiliacion from "@/components/Ciudadano/FichaAfiliacion/FichaAfiliacion";
import GeneracionCertificadoList from "@/components/Ciudadano/GenCertificado/CertificadosList";
import RenunciaWizard from "@/components/Ciudadano/Renuncia/RenunciaWizard/RenunciaWizard";
import module from "@/enums/module";
import action from "@/enums/action";
import ReclamoWizard from "@/components/Ciudadano/Reclamos/ReclamoWizard/ReclamoWizard";

const ciudadanoMenu = {
  path: '/ciudadano',
  component: DashboardLayoutMod,
  redirect: '/ciudadano/resumen-tramites',
  meta: {module: module.CIUDADANOS_RESUMEN_TRAMITES, action: [action.CONSULTAR], requiresAuth: true},
  children: [{
    path: 'resumen-tramites',
    name: 'resumen-tramites',
    component: ActividadLista,
    meta: {
      module: module.CIUDADANOS_RESUMEN_TRAMITES,
      action: [action.CONSULTAR],
      requiresAuth: true,
      title: 'Resumen de sus trámites'
    },
  },
    {
      path: 'afiliacion/solicitud',
      name: 'afiliacion-solicitud',
      component: AfiliacionWizard,
      meta: {
        module: module.CIUDADANOS_AFILIACION_PARTIDO,
        action: [action.CREAR],
        requiresAuth: true,
        title: 'Solicitud para Afiliación'
      },
    },
    {
      path: 'afiliacion/:id',
      name: 'afiliacion-id',
      component: VerAfiliacion,
      meta: {
        module: module.CIUDADANOS_AFILIACION_PARTIDO,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Afiliación a partido político'
      },
    },
    {
      path: 'ficha',
      name: 'ficha',
      component: FichaAfiliacion,
      meta: {
        module: module.CIUDADANOS_FICHA_AFILIACION,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Ficha de Afiliación'
      },
    },
    {
      path: 'gencertificado',
      name: 'GeneracionCertificado',
      component: GeneracionCertificadoList,
      meta: {
        module: module.CIUDADANOS_GENERACION_CERTIFICADO,
        action: [action.CREAR],
        requiresAuth: true
      },
    },
    {
      path: 'renuncia-partido',
      name: 'renuncia-partido-politico',
      component: RenunciaWizard,
      meta: {
        module: module.CIUDADANOS_RENUNCIA_PARTIDO_POLITICO,
        action: [action.CREAR],
        requiresAuth: true,
        title: 'Renuncia a Partido Político'
      },
    },
    {
      path: 'reclamo',
      name: 'reclamo',
      component: ReclamoWizard,
      meta: {
        module: module.CIUDADANOS_RECLAMOS,
        action: [action.CREAR],
        requiresAuth: true,
        title: 'Reclamos'
      },
    }
  ]
};

export default ciudadanoMenu
